// Webpack Imports
import * as bootstrap from 'bootstrap';


// (function () {
// 	'use strict';

// 	// Focus input if Searchform is empty
// 	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
// 		el.addEventListener('submit', function (e) {
// 			var search = el.querySelector('input');
// 			if (search.value.length < 1) {
// 				e.preventDefault();
// 				search.focus();
// 			}
// 		});
// 	});

// 	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
// 	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
// 	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
// 		return new bootstrap.Popover(popoverTriggerEl, {
// 			trigger: 'focus',
// 		});
// 	});
// })();




document.addEventListener("DOMContentLoaded", function () {
	// Привязка хедера при скролинге
	window.addEventListener('scroll', function () {
		if (window.scrollY > 100) {
			document.getElementById('navbar_top').classList.add('fixed-top');
			let navbar_height = document.querySelector('.navbar').offsetHeight;
			document.body.style.marginTop = navbar_height + 'px';
		} else {
			document.getElementById('navbar_top').classList.remove('fixed-top');
			document.body.style.marginTop = '0';
		}
	});

	// Подчеркивание меню 
	let [menulist] = document.getElementsByClassName("megamenu");
	menulist.insertAdjacentHTML("beforeend", '<div id="marker"></div>');
	let marker = document.getElementById("marker");
	//get menu list
	let list = document.querySelectorAll(".megamenu li");
	//get active menu item
	let activeLeft, activeWidth;
	//listen menu
	for (let i = 0; i < list.length; i++) {
		if (list[i].classList.contains("current-menu-item")) {
			activeLeft = list[i].offsetLeft;
			activeWidth = list[i].offsetWidth;
		}
		marker.style.width = `${activeWidth}px`;
		marker.style.left = `${activeLeft}px`;

		list[i].addEventListener("mouseover", function (e) {
			marker.style.width = `${e.target.offsetWidth}px`;
			marker.style.left = `${e.target.offsetLeft}px`;
		});
		list[i].addEventListener("mouseout", function (e) {
			marker.style.width = `${activeWidth}px`;
			marker.style.left = `${activeLeft}px`;
		});
	}



	// Слайдер на главной странице
	// if (document.querySelector('.custom-swiper')) {
	// 	document.querySelector('.custom-swiper').insertAdjacentHTML("beforeend", '<div class="swiper-button-next"></div><div class="swiper-button-prev"></div>')
	// 	document.querySelector('.custom-swiper > .elementor-container').classList.add('swiper-wrapper');
	// 	document.querySelector('.custom-swiper ').insertAdjacentHTML("beforeend", '<div class="slider_footer"></div><div class="slider_footer2"></div>');
	// 	const swiper = new Swiper('.custom-swiper', {
	// 		loop: true,
	// 		speed: 500,
	// 		// autoplay: {
	// 		// 	delay: 5000,
	// 		//   },
	// 		navigation: {
	// 			enabled: true,
	// 			nextEl: '.swiper-button-next',
	// 			prevEl: '.swiper-button-prev',
	// 		},
	// 	});
	// }

	const swiper2 = new Swiper('.product_swiper', {
		loop: true,
		speed: 500,
		autoplay: {
			delay: 5000,
		},
		navigation: {
			enabled: true,
			nextEl: '.product_swiper-button-next',
			prevEl: '.product_swiper-button-prev',
		},
	});


});



// Продукты на главной странице	

function sortGallery(target) {
	let arr = document.querySelectorAll('[data]');
	arr.forEach((elem) => {
		let data = (elem.getAttribute('data')).split(',');
		data.splice(-1, 1);

		if (data.includes(target)) {
			elem.classList.remove("show");
			elem.classList.add("hide");
			setTimeout(() => {
				elem.style.display = 'none';
			}, 500);
		} else {
			elem.style.display = 'block';
			setTimeout(() => {
				elem.classList.remove("hide");
				elem.classList.add("show");
			}, 100);
		}
	});
}

let tagList = document.querySelectorAll('#taglist');

if (tagList.length > 0) {
	tagList[0].addEventListener('click', e => {
		[...tagList[0].children].map((li) => {
			li.classList.remove('active')
		});
		e.target.classList.add("active");
		sortGallery(e.target.innerHTML);

	});
}

// --------------










let markers = [
	[
		30.559851,
		46.476292,
		"Великий Дальник"
	],
	[
		37.7466719,
		48.1338824,
		"Авдіївка"
	],
	[
		35.15522,
		46.69636,
		"Якимівка"
	],
	[
		33.1169742,
		48.670609,
		"Олександрія"
	],
	[
		34.443169,
		48.009911,
		"Олександропіль"
	],
	[
		29.9601889,
		47.7178669,
		"Ананьєв"
	],
	[
		29.0222111,
		50.0301392,
		"Андрушівка"
	],
	[
		24.186893,
		49.275032,
		"Антонівка"
	],
	[
		33.7180001,
		47.6617478,
		"Апостолове"
	],
	[
		38.0020994,
		48.5894123,
		"Бахмут"
	],
	[
		29.431517,
		45.9962017,
		"Арциз"
	],
	[
		34.8868923,
		50.3115386,
		"Охтирка"
	],
	[
		36.1916466,
		49.9000446,
		"Бабаї"
	],
	[
		30.0290694,
		50.642412,
		"Бабинці"
	],
	[
		35.2169637,
		47.7472362,
		"Балабине"
	],
	[
		36.8786912,
		49.4628203,
		"Балаклія"
	],
	[
		29.62633310082387,
		47.9321168,
		"Балта"
	],
	[
		27.6813781,
		49.077621,
		"Бар"
	],
	[
		27.66666,
		50.29369,
		"Баранівка"
	],
	[
		37.0287573,
		48.9070045,
		"Барвінкове"
	],
	[
		31.3256722,
		50.3645295,
		"Баришівка"
	],
	[
		32.8165107,
		51.1801374,
		"Бахмач"
	],
	[
		32.4388921,
		47.4033486,
		"Баштанка"
	],
	[
		36.29848,
		49.87072,
		"Безлюдівка"
	],
	[
		33.200718,
		47.3507,
		"Біла криниця"
	],
	[
		30.1158069,
		49.7969703,
		"Біла Церква"
	],
	[
		30.345784,
		46.1909823,
		"Білгород-Дністровський"
	],
	[
		39.5911619,
		49.2068078,
		"Біловодськ"
	],
	[
		30.22785,
		50.390171,
		"Білогородка"
	],
	[
		32.44537,
		46.63078,
		"Білозерка"
	],
	[
		37.05791,
		48.53313,
		"Білозерське"
	],
	[
		38.73539,
		49.52637,
		"білокуракине"
	],
	[
		34.29700237909961,
		51.146676150000005,
		"Білопілля"
	],
	[
		30.2014161,
		46.4826109,
		"Біляївка"
	],
	[
		28.5814912,
		49.8940442,
		"Бердичів"
	],
	[
		36.7887623,
		46.755678,
		"Бердянськ"
	],
	[
		22.6453246,
		48.2050985,
		"Берегово"
	],
	[
		24.938854,
		49.4450296,
		"Бережани"
	],
	[
		31.4689158,
		50.3132713,
		"Березань"
	],
	[
		26.7524487,
		51.0035653,
		"Березне"
	],
	[
		36.0674414,
		49.9043196,
		"Березівка"
	],
	[
		33.416743,
		46.8357749,
		"Берислав"
	],
	[
		32.15938,
		48.05729,
		"Бобринець"
	],
	[
		24.2973288,
		49.6375183,
		"Бібрка"
	],
	[
		31.3860852,
		50.7415033,
		"Бобровиця"
	],
	[
		35.5220539,
		50.1601711,
		"Богодухів"
	],
	[
		24.5367795,
		48.8072818,
		"Богородчани"
	],
	[
		30.8733,
		49.54765,
		"Богуслав"
	],
	[
		28.6132404,
		45.6779137,
		"Болград"
	],
	[
		23.8598949,
		49.0663203,
		"Болехів"
	],
	[
		32.4263156,
		51.2534475,
		"Борзна"
	],
	[
		23.41735375217583,
		49.288601650000004,
		"Борислав"
	],
	[
		30.95077,
		50.3512101,
		"Бориспіль"
	],
	[
		29.9278296,
		50.6437677,
		"Бородянка"
	],
	[
		26.0401871,
		48.8025557,
		"Борщів"
	],
	[
		30.2847595,
		50.3356709,
		"Боярка"
	],
	[
		30.7900482,
		50.5111168,
		"Бровари"
	],
	[
		25.1437921,
		50.0833041,
		"Броди"
	],
	[
		29.51889,
		50.28305,
		"Брусилів"
	],
	[
		23.9466945,
		49.9025343,
		"Брюховичі"
	],
	[
		24.6341893,
		49.2516287,
		"Бурштин"
	],
	[
		33.8288042,
		51.1960431,
		"Буринь"
	],
	[
		24.6089531,
		49.965355,
		"Буськ"
	],
	[
		30.2106925,
		50.5503127,
		"Буча"
	],
	[
		25.389969,
		49.0630503,
		"Бучач"
	],
	[
		35.6088208,
		49.8305999,
		"Валки"
	],
	[
		32.7228573,
		50.4982561,
		"Варва"
	],
	[
		28.44017,
		48.989071,
		"Василівка"
	],
	[
		30.32158,
		50.17387,
		"Васильків"
	],
	[
		36.03035,
		48.21041,
		"Васильківка"
	],
	[
		31.042974623545412,
		49.0113418,
		"Ватутіне"
	],
	[
		33.2997671,
		47.3159392,
		"Велика Олександрівка"
	],
	[
		22.388021,
		48.56377,
		"Великі лази"
	],
	[
		22.45812,
		48.88985,
		"Великий Березний"
	],
	[
		24.0147396,
		47.973549,
		"Великий Бичків"
	],
	[
		26.34487,
		50.656239,
		"Великий Житин"
	],
	[
		25.2753013,
		50.7376082,
		"Великий Омеляник"
	],
	[
		30.5759542,
		46.3467158,
		"Великодолинське"
	],
	[
		34.3347779,
		48.6541915,
		"Верхньодніпровськ"
	],
	[
		34.24232,
		48.48404,
		"Верхівцеве"
	],
	[
		31.2367979,
		47.356307,
		"Веселинове"
	],
	[
		34.9211323,
		47.0179164,
		"Веселе"
	],
	[
		29.58309,
		45.40306,
		"Вилкове"
	],
	[
		24.1381342,
		49.8168013,
		"Винники"
	],
	[
		28.467975,
		49.2320162,
		"Вінниця"
	],
	[
		23.036008,
		48.1403967,
		"Виноградів"
	],
	[
		25.75127,
		49.90162,
		"Вишнівець"
	],
	[
		34.17503,
		49.251709,
		"Вишневе"
	],
	[
		34.17503,
		49.251709,
		"Вишневе"
	],
	[
		24.319319,
		50.8474669,
		"Володимир-Волинський"
	],
	[
		31.3338636,
		47.5679582,
		"Вознесенськ"
	],
	[
		37.4998511,
		47.5984285,
		"Волноваха"
	],
	[
		23.1888322,
		48.7146406,
		"Воловець"
	],
	[
		29.9280475,
		49.5224979,
		"Володарка"
	],
	[
		28.445337,
		50.5959845,
		"Хорошев (Володарськ-Волинський)"
	],
	[
		26.2126215,
		49.5358446,
		"Волочиськ"
	],
	[
		36.9370028,
		50.2928843,
		"Вовчанськ"
	],
	[
		34.02328,
		48.49365,
		"Вільногірськ"
	],
	[
		35.43159,
		47.9433,
		"Вільнянськ"
	],
	[
		30.1562891,
		50.5457287,
		"Ворзель"
	],
	[
		36.1286649,
		49.8911681,
		"високий"
	],
	[
		30.485121,
		50.5824332,
		"Вишгород"
	],
	[
		33.9950534,
		50.3701299,
		"Гадяч"
	],
	[
		29.8677468,
		48.3366182,
		"Гайворон"
	],
	[
		29.3893874,
		48.8120874,
		"Гайсин"
	],
	[
		30.396284,
		50.358547,
		"Гатне"
	],
	[
		34.8068643,
		46.1738032,
		"Генічеськ"
	],
	[
		30.3059171,
		50.259673,
		"Глеваха"
	],
	[
		33.2507308,
		49.392047,
		"Глобине"
	],
	[
		33.91705280116011,
		51.6746617,
		"Глухів"
	],
	[
		28.338343,
		49.0933696,
		"Гнівань"
	],
	[
		32.5345028,
		46.5320381,
		"Гола Пристань"
	],
	[
		25.4952722,
		48.6720598,
		"Городенка"
	],
	[
		28.09822513,
		49.36719905,
		"Городище"
	],
	[
		31.595545,
		51.8915393,
		"Городня"
	],
	[
		23.6465626,
		49.784596,
		"Городок"
	],
	[
		24.7600734,
		50.4986166,
		"Горохів"
	],
	[
		23.199945,
		49.800186,
		"Гостинцеве"
	],
	[
		30.25909,
		50.58826,
		"Гостомель"
	],
	[
		32.4289258,
		50.1206044,
		"Гребінка"
	],
	[
		30.1763499,
		49.95346,
		"Гребінки"
	],
	[
		31.414376,
		49.9231782,
		"Григорівка"
	],
	[
		36.2656849,
		47.6655382,
		"Гуляйполе"
	],
	[
		34.729797,
		49.110321,
		"Гупалівка"
	],
	[
		26.1996027,
		49.0707755,
		"Гусятин"
	],
	[
		24.135963,
		49.751785,
		"Давидів"
	],
	[
		24.6286388,
		48.5277174,
		"Делятин"
	],
	[
		36.1205965,
		50.107307,
		"Дергачі"
	],
	[
		37.8501378,
		48.3970469,
		"Торецьк"
	],
	[
		37.2591,
		48.30791,
		"Мирноград"
	],
	[
		34.6068797,
		48.5167748,
		"Кам'янське"
	],
	[
		35.0417711,
		48.4680221,
		"Дніпро"
	],
	[
		35.0028481,
		47.3899205,
		"Дніпрорудне"
	],
	[
		37.0903243,
		48.4683035,
		"Добропілля"
	],
	[
		24.3857048,
		50.2057172,
		"Добротвір"
	],
	[
		23.9789588,
		48.9782308,
		"Долина"
	],
	[
		32.76991032352073,
		48.11282,
		"Долинська"
	],
	[
		23.5061662,
		49.3513996,
		"Дрогобич"
	],
	[
		37.524945,
		48.6198614,
		"Дружківка"
	],
	[
		24.0876223,
		49.9026751,
		"Дубляни"
	],
	[
		25.743323875936717,
		50.3974013,
		"Дубно"
	],
	[
		26.577673058120553,
		51.57636225,
		"Дубровиця"
	],
	[
		26.8476798,
		48.886649,
		"Дунаївці"
	],
	[
		30.3078042,
		50.7835487,
		"Димер"
	],
	[
		27.8047443,
		50.872091,
		"Ємільчине"
	],
	[
		30.1066179,
		49.2478012,
		"Жашків"
	],
	[
		33.5027797,
		48.3465174,
		"Жовті Води"
	],
	[
		29.878965,
		47.835659,
		"жеребкове"
	],
	[
		24.1426813,
		49.3831172,
		"Жидачів"
	],
	[
		28.6692345,
		50.2598298,
		"Житомир"
	],
	[
		28.1147317,
		49.0354593,
		"Жмеринка"
	],
	[
		23.9711967,
		50.056134,
		"Жовква"
	],
	[
		25.286665433679826,
		48.47418125,
		"Заболотів"
	],
	[
		30.6791472,
		50.5667713,
		"Зазим'я"
	],
	[
		25.735898,
		48.6402658,
		"Заліщики"
	],
	[
		35.1182867,
		47.8507859,
		"Запоріжжя"
	],
	[
		28.648407,
		50.2312225,
		"Зарічани"
	],
	[
		33.442723,
		49.2932576,
		"Зарічне"
	],
	[
		25.8457245,
		48.5224375,
		"Заставна"
	],
	[
		25.7768485,
		49.6607393,
		"Збараж"
	],
	[
		25.1386197,
		49.6645222,
		"Зборів"
	],
	[
		30.969734016356565,
		49.0725767,
		"Звенигородка"
	],
	[
		31.7691817,
		50.4950666,
		"Згурівка"
	],
	[
		26.248762195978088,
		50.53309135,
		"Здолбунів"
	],
	[
		33.6474574,
		47.5668051,
		"Зеленодольськ"
	],
	[
		34.35768,
		50.21026,
		"Зіньків"
	],
	[
		36.354776,
		49.6815177,
		"Зміїв"
	],
	[
		32.6659476,
		48.7199609,
		"Знам'янка"
	],
	[
		32.0427439,
		49.6689719,
		"Золотоноша"
	],
	[
		24.8988858,
		49.8056522,
		"Золочів"
	],
	[
		24.358873,
		50.6374232,
		"Іваничі"
	],
	[
		30.300426217690763,
		50.2860421,
		"Іванків"
	],
	[
		24.5207477,
		48.7481718,
		"Івано-Франківськ"
	],
	[
		28.8361514,
		45.3511307,
		"Ізмаїл"
	],
	[
		37.2784125,
		49.1913721,
		"Ізюм"
	],
	[
		35.275539,
		48.4043673,
		"Іларіонове"
	],
	[
		29.2024356,
		49.1136358,
		"Іллінці"
	],
	[
		30.653466,
		46.3020943,
		"Чорноморськ"
	],
	[
		33.2505816,
		47.7320864,
		"Інгулець"
	],
	[
		30.2448725,
		50.5206777,
		"Ірпінь"
	],
	[
		23.0417599,
		48.31924,
		"Іршава"
	],
	[
		32.3910144,
		50.8623444,
		"Ічня"
	],
	[
		30.8226786,
		49.8650658,
		"Кагарлик"
	],
	[
		24.65123217034155,
		50.574619999999996,
		"Козятин"
	],
	[
		33.2843632,
		46.257184,
		"Каланчак"
	],
	[
		28.023899701409825,
		48.7503443,
		"Калинівка"
	],
	[
		28.023899701409825,
		48.7503443,
		"Калинівка"
	],
	[
		24.3613198,
		49.028894,
		"Калуш"
	],
	[
		26.5852225,
		48.6784597,
		"Кам'янець-Подільський"
	],
	[
		23.579086,
		49.01339,
		"Кам'янка"
	],
	[
		24.3453414,
		50.1046656,
		"Кам'янка-Бузька"
	],
	[
		34.4109101,
		47.4900938,
		"Кам'янка -Дніпровська"
	],
	[
		34.6068797,
		48.5167748,
		"Кам'янське"
	],
	[
		36.70292,
		47.32944,
		"Комиш-Зоря"
	],
	[
		37.45582,
		48.64025,
		"Комишуваха"
	],
	[
		31.4610802,
		49.7551031,
		"Канів"
	],
	[
		35.1374845,
		49.4537175,
		"Карлівка"
	],
	[
		33.4817825,
		46.8054626,
		"Каховка"
	],
	[
		25.4648622,
		50.8333448,
		"Ківерці"
	],
	[
		30.5241361,
		50.4500336,
		"Київ"
	],
	[
		29.2652788,
		45.4409767,
		"Кілія"
	],
	[
		35.3696143,
		46.3717985,
		"Кирилівка"
	],
	[
		32.2656283,
		48.5105805,
		"Кропивницький"
	],
	[
		34.8545508,
		48.5495226,
		"Обухівка"
	],
	[
		30.0095,
		50.58414,
		"Клавдієво- Тарасове"
	],
	[
		34.2002778,
		49.1433333,
		"Кобеляки"
	],
	[
		31.2085145,
		46.6612599,
		"Коблево"
	],
	[
		24.708894,
		51.2120538,
		"Ковель"
	],
	[
		37.6840775,
		49.6295221,
		"Ківшарівка"
	],
	[
		29.274603,
		49.2991811,
		"Кожанка"
	],
	[
		31.1167509,
		50.9160647,
		"Козелець"
	],
	[
		24.65123217034155,
		50.574619999999996,
		"Козятин"
	],
	[
		25.0380538,
		48.5259211,
		"Коломия"
	],
	[
		30.943207,
		46.8193867,
		"Доброслав"
	],
	[
		33.6330875,
		49.0140647,
		"Горішні Плавні"
	],
	[
		36.3749418,
		48.8750766,
		"Слобожанське"
	],
	[
		33.206675,
		51.2397495,
		"Конотоп"
	],
	[
		37.6923705,
		48.534859,
		"Костянтинівка"
	],
	[
		37.6923705,
		48.534859,
		"Костянтинівка"
	],
	[
		25.9085276,
		49.1068616,
		"Копичинці"
	],
	[
		27.159712,
		50.6194566,
		"Корець"
	],
	[
		28.6416207,
		50.9492852,
		"Коростень"
	],
	[
		29.0584885,
		50.3201518,
		"Коростишів"
	],
	[
		31.2556741,
		49.418037,
		"Корсунь -Шевченківський"
	],
	[
		32.2514,
		51.77444,
		"Корюківка"
	],
	[
		25.0983417,
		48.315802,
		"Косів"
	],
	[
		26.43391381313544,
		50.882657699999996,
		"Костопіль"
	],
	[
		34.7496951,
		50.0621097,
		"Котельва"
	],
	[
		34.9324,
		49.132568,
		"Котовка"
	],
	[
		29.5304957,
		47.7497422,
		"Подільськ"
	],
	[
		30.3337903,
		50.4904717,
		"Коцюбинське"
	],
	[
		37.5843812,
		48.7389415,
		"Краматорськ"
	],
	[
		26.9709084,
		49.6544431,
		"Красилів"
	],
	[
		37.1442529,
		48.2809468,
		"Покровськ"
	],
	[
		35.4494234,
		49.3741326,
		"Красноград"
	],
	[
		28.398561,
		48.916512,
		"Красне"
	],
	[
		35.1493710000535,
		50.046746150000004,
		"Краснокутська"
	],
	[
		37.8168012,
		48.9801314,
		"Лиман"
	],
	[
		25.7260783,
		50.0960966,
		"Кременець"
	],
	[
		38.2178525,
		49.0463189,
		"Кремінна"
	],
	[
		33.43081884909263,
		49.09285285,
		"Кременчук"
	],
	[
		30.3425878,
		47.9532217,
		"Криве Озеро"
	],
	[
		33.3917703,
		47.9102734,
		"Кривий Ріг"
	],
	[
		24.662249833323152,
		48.9021744,
		"Крихівці"
	],
	[
		33.3875984,
		51.5548654,
		"Кролевець"
	],
	[
		28.424183,
		49.709641,
		"Крижанівка"
	],
	[
		30.371622,
		50.371929,
		"Крюковщина"
	],
	[
		25.8500623,
		51.3481736,
		"Вараш"
	],
	[
		36.65108,
		47.3624,
		"Більмак (Куйбишеве)"
	],
	[
		37.6141992,
		49.7132963,
		"Куп'янськ"
	],
	[
		37.2826414,
		47.9835214,
		"Курахово"
	],
	[
		35.20981,
		47.71671,
		"Кушугум"
	],
	[
		29.2567642,
		48.6810505,
		"Ладижин"
	],
	[
		26.0780148,
		49.8734191,
		"Ланівці"
	],
	[
		34.4761301,
		50.5814148,
		"Лебедин"
	],
	[
		29.0207508,
		49.2159844,
		"Липовець"
	],
	[
		24.121082,
		49.835476,
		"Лисиничі"
	],
	[
		38.4285981,
		48.917267,
		"Лисичанськ"
	],
	[
		36.3160254,
		48.8842428,
		"Лозова"
	],
	[
		27.2989948,
		49.2947567,
		"Лозове"
	],
	[
		33.2741725,
		50.3595181,
		"Лохвиця"
	],
	[
		33.0030821,
		50.0118206,
		"Лубни"
	],
	[
		25.320078,
		50.7450733,
		"Луцьк"
	],
	[
		28.1311484,
		49.1920902,
		"Лисянка"
	],
	[
		24.0315921,
		49.841952,
		"Львів"
	],
	[
		25.5048264,
		51.7632795,
		"Любешів"
	],
	[
		24.0396571,
		51.2274054,
		"Любомль"
	],
	[
		35.9185185,
		49.9435604,
		"Люботин"
	],
	[
		34.9291661,
		48.9145571,
		"Магдалинівка"
	],
	[
		29.8068986,
		50.4639897,
		"Макаров"
	],
	[
		36.1706244,
		50.0561227,
		"Мала Данилівка"
	],
	[
		29.2647319,
		50.7680258,
		"Малин"
	],
	[
		25.82176131625158,
		48.362641350000004,
		"Мамаївці"
	],
	[
		25.537878,
		51.2908106,
		"Маневичі"
	],
	[
		34.649194,
		47.6490555,
		"Марганець"
	],
	[
		37.5499621,
		47.0957648,
		"Маріуполь"
	],
	[
		30.26836,
		46.413799,
		"Маяки"
	],
	[
		23.505550105321205,
		48.5291,
		"Міжгір'я"
	],
	[
		36.7322839,
		48.2553506,
		"Межова"
	],
	[
		35.3827281,
		46.8467267,
		"Мелітополь"
	],
	[
		32.22117135,
		51.5236268,
		"Мена"
	],
	[
		36.0628675,
		49.8183386,
		"Мерефа"
	],
	[
		30.68032833663166,
		46.38948265,
		"Лиманка"
	],
	[
		33.6113889,
		49.9658333,
		"Миргород"
	],
	[
		37.7344444,
		47.4242451,
		"мирне"
	],
	[
		30.9824887,
		49.6583412,
		"Миронівка"
	],
	[
		26.77746,
		48.7936228,
		"Михайлівка"
	],
	[
		26.77746,
		48.7936228,
		"Михайлівка"
	],
	[
		27.7991124,
		48.442544,
		"Могилів-Подільський"
	],
	[
		35.59742,
		47.20653,
		"Молочанськ"
	],
	[
		29.8007253,
		48.9944069,
		"Монастирище"
	],
	[
		23.8700537,
		49.1536011,
		"Моршин"
	],
	[
		23.147933,
		49.79235,
		"Мостиська"
	],
	[
		22.7185112,
		48.4421438,
		"Мукачеве"
	],
	[
		30.172302,
		50.441376,
		"Мила"
	],
	[
		24.5684038,
		48.6335887,
		"Надвірна"
	],
	[
		29.0913215,
		51.2037677,
		"Народичі"
	],
	[
		31.8806289,
		51.0464747,
		"Ніжин"
	],
	[
		30.1015029,
		50.56801,
		"Немішаєве"
	],
	[
		28.8430131,
		48.9654035,
		"Немирів"
	],
	[
		28.858704,
		48.687286,
		"Нестерварка"
	],
	[
		26.6496599,
		50.3338348,
		"Нетішин"
	],
	[
		25.06188,
		48.400612,
		"Микитинці"
	],
	[
		31.9939666,
		46.9758615,
		"Миколаїв"
	],
	[
		31.9939666,
		46.9758615,
		"Миколаїв"
	],
	[
		37.7619191,
		48.8610868,
		"Миколаївка"
	],
	[
		34.38317932,
		47.5761258,
		"Нікополь"
	],
	[
		28.6396035,
		50.6933301,
		"Нова Борова"
	],
	[
		35.8601594,
		49.7181212,
		"Нова Водолага"
	],
	[
		33.3741329,
		46.7549303,
		"Нова Каховка"
	],
	[
		31.7739735,
		47.310996,
		"Нова Одеса"
	],
	[
		33.2779899,
		52.004259,
		"Новгород -Сіверський"
	],
	[
		38.999476594826504,
		48.9727659,
		"Новоайдар"
	],
	[
		39.627,
		48.26706,
		"Новоолександрівка"
	],
	[
		24.1648399,
		50.7224829,
		"Нововолинськ"
	],
	[
		27.6066973,
		50.5917622,
		"Новоград-Волинський"
	],
	[
		37.3399704,
		48.1997174,
		"Новогродівка"
	],
	[
		27.4311004,
		48.58485,
		"Новодністровськ"
	],
	[
		31.65121456444669,
		48.80062325,
		"Новомиргород"
	],
	[
		35.2595541,
		48.6358512,
		"Новомосковськ"
	],
	[
		39.139120809137836,
		49.531048150000004,
		"Новопсков"
	],
	[
		22.5127253,
		49.0437476,
		"Новоселиця"
	],
	[
		37.5817221,
		47.7167369,
		"Новотроїцьке"
	],
	[
		31.531643605039136,
		48.31470075,
		"Новоукраїнка"
	],
	[
		23.5661291,
		49.9316152,
		"Новояворівськ"
	],
	[
		34.3148631,
		49.3338321,
		"нові Санжари"
	],
	[
		32.5106596,
		47.6933814,
		"новий Буг"
	],
	[
		24.1386133,
		49.4696071,
		"новий Розділ"
	],
	[
		31.5812258,
		50.9377744,
		"Носівка"
	],
	[
		30.6269696,
		50.1101633,
		"Обухів"
	],
	[
		30.4448614,
		46.2473734,
		"Овідіополь"
	],
	[
		28.8026718,
		51.3259771,
		"Овруч"
	],
	[
		30.7322878,
		46.4843023,
		"Одеса"
	],
	[
		27.64881,
		51.22272,
		"Олевськ"
	],
	[
		34.1149341,
		47.6546589,
		"Покров"
	],
	[
		35.7789871,
		47.5691902,
		"Орєхов"
	],
	[
		30.87750742,
		50.95307035,
		"Остер"
	],
	[
		26.5203627,
		50.329021,
		"Острог"
	],
	[
		31.5452994,
		46.6145957,
		"Очаків"
	],
	[
		35.8703535,
		48.5317201,
		"Павлоград"
	],
	[
		30.8475997,
		48.045745,
		"Первомайськ"
	],
	[
		30.8475997,
		48.045745,
		"Первомайськ"
	],
	[
		36.22089,
		49.37393,
		"Первомайський"
	],
	[
		24.5584141,
		49.6693553,
		"Перемишляни"
	],
	[
		22.48764,
		48.73707,
		"Перечин"
	],
	[
		35.35915,
		49.01825,
		"Перещепине"
	],
	[
		31.4447327,
		50.0643984,
		"Переяслав (Переяслав -Хмельницький)"
	],
	[
		36.402296,
		48.3505864,
		"Першотравенськ"
	],
	[
		36.402296,
		48.3505864,
		"Першотравенськ"
	],
	[
		29.5931036,
		50.6968561,
		"Пісківка"
	],
	[
		36.1239316,
		49.9622881,
		"Пісочин"
	],
	[
		36.24322829,
		48.09770735,
		"Петриков"
	],
	[
		34.630883271335975,
		48.72499185,
		"Петриківка"
	],
	[
		31.1687444,
		50.7689684,
		"Петрівське"
	],
	[
		39.26685,
		48.80813,
		"Петропавлівка"
	],
	[
		30.345961,
		50.437199,
		"Петропавлівська Борщагівка"
	],
	[
		32.5011111,
		50.2361111,
		"Пирятин"
	],
	[
		29.2579157,
		49.4848166,
		"Погребище"
	],
	[
		26.1440799,
		49.531358,
		"Підволочиськ"
	],
	[
		35.1013002,
		48.5681471,
		"Підгородне"
	],
	[
		35.1013002,
		48.5681471,
		"Підгородне"
	],
	[
		38.14931253551137,
		48.59922,
		"Покровське"
	],
	[
		38.14931253551137,
		48.59922,
		"Покровське"
	],
	[
		36.2622651,
		47.4776419,
		"Пологи"
	],
	[
		27.5085733,
		50.1194505,
		"Полонне"
	],
	[
		34.54449222533195,
		49.60250085,
		"Полтава"
	],
	[
		38.3777033,
		48.6322687,
		"Попасна"
	],
	[
		29.4594464,
		49.9452873,
		"Попільня"
	],
	[
		35.63896,
		46.73,
		"Приазовське"
	],
	[
		32.3866658,
		50.5950864,
		"Прилуки"
	],
	[
		36.36642885,
		46.71268395,
		"Приморськ"
	],
	[
		35.328251,
		47.249451,
		"Пришиб"
	],
	[
		33.86814402066433,
		51.3366117,
		"Путивль"
	],
	[
		34.305149,
		48.653641,
		"Пушкарівка"
	],
	[
		33.7016613,
		48.4124318,
		"П'ятихатки"
	],
	[
		23.6240014,
		50.230654,
		"Рава -Руська"
	],
	[
		24.6397908,
		50.2808744,
		"Радехів"
	],
	[
		29.2289588,
		50.4961812,
		"Радомишль"
	],
	[
		25.260528604494663,
		50.12501745,
		"Радивилів"
	],
	[
		30.0711363,
		46.8546716,
		"Роздільна"
	],
	[
		30.473034,
		49.6867282,
		"Рокитне"
	],
	[
		24.52458,
		51.67145,
		"Ратне"
	],
	[
		24.2057063,
		48.0556765,
		"Рахів"
	],
	[
		28.29894939,
		45.44709005,
		"Рені"
	],
	[
		34.0791667,
		49.5586111,
		"Решетилівка"
	],
	[
		31.04118,
		49.96822,
		"Ржищів"
	],
	[
		26.5208033,
		51.2074112,
		"Рівне"
	],
	[
		24.6105811,
		49.4092703,
		"Рогатин"
	],
	[
		37.2034069,
		48.3536652,
		"Родинське"
	],
	[
		25.2712543,
		50.916332,
		"Рожище"
	],
	[
		37.0675861,
		47.3866992,
		"Розівка"
	],
	[
		33.4877,
		50.74207,
		"Ромни"
	],
	[
		38.3725819,
		49.0329045,
		"Рубіжне"
	],
	[
		23.87761848,
		49.8408678,
		"Рудно"
	],
	[
		23.1969805,
		49.5182487,
		"Самбір"
	],
	[
		26.6171275,
		51.3350028,
		"Сарни"
	],
	[
		37.6952892,
		47.1701321,
		"Сартана"
	],
	[
		22.9895489,
		48.5460735,
		"Свалява"
	],
	[
		38.1456729,
		49.4176663,
		"Сватове"
	],
	[
		33.20721,
		49.04537,
		"Світловодськ"
	],
	[
		37.5575696,
		49.0337642,
		"Святогірськ"
	],
	[
		38.4936024,
		48.9477095,
		"Сєвєродонецьк"
	],
	[
		37.3018921,
		48.15015,
		"Селидове"
	],
	[
		28.347152269027717,
		48.79052795,
		"Семенівка"
	],
	[
		28.347152269027717,
		48.79052795,
		"Семенівка"
	],
	[
		35.5246984,
		48.3269304,
		"Синельникове"
	],
	[
		32.910339,
		46.1203932,
		"Скадовськ"
	],
	[
		29.6624138,
		49.7337685,
		"Сквира"
	],
	[
		23.5140979,
		49.0378559,
		"Сколе"
	],
	[
		26.8658254,
		50.2962398,
		"Славута"
	],
	[
		30.7562301,
		51.5201397,
		"Славутич"
	],
	[
		37.6058241,
		48.8522691,
		"Слов'янськ"
	],
	[
		31.889824655794214,
		49.21208265,
		"Сміла"
	],
	[
		32.03808990394229,
		49.59840235,
		"Снігурівка"
	],
	[
		25.5518046,
		48.4523142,
		"Снятин"
	],
	[
		24.2770538,
		50.4791313,
		"Сокаль"
	],
	[
		27.40872761179787,
		48.44726665,
		"Сокиряни"
	],
	[
		23.9791691,
		49.7797678,
		"Сокільники"
	],
	[
		38.0627964,
		48.6948731,
		"Соледар"
	],
	[
		34.87713,
		48.20423,
		"Солоне"
	],
	[
		36.0681717,
		49.984881,
		"Солоницівка"
	],
	[
		24.008862,
		49.756359,
		"Солонка"
	],
	[
		23.8747013,
		47.9470202,
		"Солотвино"
	],
	[
		24.2563161,
		50.2909116,
		"Соснівка"
	],
	[
		30.365957,
		50.41188,
		"Софіївська Борщагівка"
	],
	[
		30.1921389,
		49.3897213,
		"Ставище"
	],
	[
		24.438565,
		51.4422955,
		"Стара Вижівка"
	],
	[
		38.9216444,
		49.2829156,
		"Старобільськ"
	],
	[
		27.2087889,
		49.756163,
		"Старокостянтинів"
	],
	[
		30.41108512149154,
		50.6484347,
		"старі Петрівці"
	],
	[
		23.0022677,
		49.44406,
		"Старий Самбір"
	],
	[
		23.556093141489633,
		49.29867195,
		"Стебник"
	],
	[
		25.7207993,
		48.1629489,
		"Сторожинець"
	],
	[
		30.226139,
		50.454021,
		"стоянка"
	],
	[
		23.8530863,
		49.255875,
		"Стрий"
	],
	[
		34.3289305,
		50.7696518,
		"Суми"
	],
	[
		33.4296736278817,
		46.755324099999996,
		"Таврійськ"
	],
	[
		30.699928604227246,
		48.8891826,
		"Тальне"
	],
	[
		28.58927292715285,
		49.48026375,
		"Тарасівка"
	],
	[
		30.5023421,
		49.555498,
		"Тараща"
	],
	[
		29.151948,
		46.1821786,
		"Тарутине"
	],
	[
		29.6166537,
		45.8398696,
		"Татарбунари"
	],
	[
		24.5791062,
		48.343329,
		"Татарів"
	],
	[
		30.3272329,
		46.5050729,
		"Теплодар"
	],
	[
		25.692491,
		49.2960742,
		"Теребовля"
	],
	[
		30.745163370124395,
		49.79086855,
		"Тернівка"
	],
	[
		25.6167516,
		49.6630002,
		"Тернопіль"
	],
	[
		29.6771098,
		49.3686166,
		"Тетіїв"
	],
	[
		25.0011978,
		48.8665866,
		"Тлумач"
	],
	[
		35.7021159,
		47.2557432,
		"Токмак"
	],
	[
		28.5114332,
		48.5453497,
		"Томашпіль"
	],
	[
		34.96467,
		50.48046,
		"Тростянець"
	],
	[
		23.5064459,
		49.2783459,
		"Трускавець"
	],
	[
		28.8569476,
		48.6730485,
		"Тульчин"
	],
	[
		23.5783799,
		48.01163,
		"Тячів"
	],
	[
		37.2484374,
		47.7805058,
		"Вугледар"
	],
	[
		24.68594,
		48.959202,
		"Угринів"
	],
	[
		22.3022569,
		48.6223732,
		"Ужгород"
	],
	[
		30.4197205,
		49.8284745,
		"Узин"
	],
	[
		28.01367381475369,
		49.2948646,
		"Українка"
	],
	[
		30.2344886,
		48.327711,
		"Благовіщенське (Ульяновка)"
	],
	[
		30.2203052,
		48.7497621,
		"Умань"
	],
	[
		29.9162821,
		50.0799307,
		"Фастів"
	],
	[
		30.858065,
		46.570198,
		"Фонтанка"
	],
	[
		36.2310146,
		49.9923181,
		"Харків"
	],
	[
		32.625794,
		46.6412644,
		"Херсон"
	],
	[
		27.9491205,
		49.556175,
		"Хмільник"
	],
	[
		26.9793793,
		49.4196404,
		"Хмельницький"
	],
	[
		24.3140241,
		49.4065802,
		"Ходорів"
	],
	[
		33.2740646,
		49.7822104,
		"Хорол"
	],
	[
		26.4859086,
		48.5068418,
		"Хотин"
	],
	[
		29.9677872,
		48.812969,
		"Христинівка"
	],
	[
		23.291166,
		48.1764917,
		"Хуст"
	],
	[
		34.48986,
		48.9434,
		"Царичанка"
	],
	[
		32.7251086,
		46.6249473,
		"Олешки"
	],
	[
		30.427101,
		50.341434,
		"Чабани"
	],
	[
		33.5380219,
		46.3617756,
		"Чаплинка"
	],
	[
		24.239616,
		50.3940701,
		"Червоноград"
	],
	[
		36.57623,
		49.50817,
		"Донець"
	],
	[
		32.0587805,
		49.4447888,
		"Черкаси"
	],
	[
		25.9376532,
		48.2864702,
		"Чернівці"
	],
	[
		31.294332,
		51.494099,
		"Чернігів"
	],
	[
		25.9376532,
		48.2864702,
		"Чернівці"
	],
	[
		33.370171,
		46.645599,
		"Чорнянка"
	],
	[
		28.66573,
		50.45299,
		"Черняхів"
	],
	[
		32.6664089,
		49.0775098,
		"Чигирин"
	],
	[
		25.7925191,
		49.0160555,
		"Чортків"
	],
	[
		36.6898157,
		49.8363648,
		"Чугуїв"
	],
	[
		27.0651783,
		50.1809437,
		"Шепетівка"
	],
	[
		33.4728213,
		51.8643223,
		"Шостка"
	],
	[
		31.393139,
		49.0132605,
		"Шпола"
	],
	[
		31.9448953,
		51.8187527,
		"Сновськ"
	],
	[
		34.6487214,
		47.4970865,
		"Енергодар"
	],
	[
		36.3749418,
		48.8750766,
		"Слобожанське"
	],
	[
		31.1786814,
		47.824269,
		"Южноукраїнськ"
	],
	[
		31.0994897,
		46.6225029,
		"Южне"
	],
	[
		37.394371,
		50.131641,
		"Юр'ївка"
	],
	[
		23.3886319,
		49.9456001,
		"Яворів"
	],
	[
		31.7634861,
		50.2758913,
		"Яготин"
	],
	[
		33.778454,
		51.9481126,
		"Ямпіль"
	],
	[
		24.550955,
		48.4504129,
		"Яремче"
	],
	[
		26.832999805763755,
		49.188494250000005,
		"Ярмолинці"
	],
	[
		30.9538321,
		48.0380198,
		"Мигія"
	],
	[
		30.51796,
		50.30846,
		"Лісники"
	],
	[
		35.16111,
		49.661667,
		"Щасливе"
	],
	[
		34.571388,
		49.538055,
		"Гора"
	],
	[
		24.1081208,
		49.3373271,
		"Гніздичів"
	],
	[
		28.178461,
		49.507,
		"Журавне"
	],
	[
		29.9420464,
		49.7683208,
		"Трушки"
	],
	[
		26.05442,
		48.291088,
		"Остриця"
	],
	[
		27.49329,
		48.86993,
		"Знаменівка"
	],
	[
		34.5210515,
		49.011034,
		"Бабайківка"
	],
	[
		34.48402,
		48.86272,
		"Могилів"
	],
	[
		26.658331,
		48.970181,
		"Рудка"
	],
	[
		35.36018,
		47.805981,
		"Лежине"
	],
	[
		34.453907,
		49.031853,
		"Залелія"
	],
	[
		34.557049,
		48.819313,
		"Новопідкряж"
	],
	[
		34.755249,
		49.057732,
		"Дмухайлівка"
	],
	[
		32.836418,
		48.776211,
		"Диківка"
	],
	[
		30.371622,
		50.371929,
		"Крюківщина"
	],
	[
		34.704698793921445,
		48.728728399999994,
		"Хутірське"
	],
	[
		34.68822974132699,
		48.6705727,
		"Лобойківка"
	],
	[
		34.427502,
		49.520832,
		"Мачухи"
	],
	[
		26.957174,
		49.220711,
		"Шарівка"
	],
	[
		34.6989624,
		48.9241118,
		"Прядівка"
	],
	[
		30.322779,
		50.385208,
		"Святопетрівське"
	],
	[
		24.60182,
		48.672871,
		"Назавизів"
	],
	[
		30.776831,
		50.114819,
		"Трипілля"
	],
	[
		32.5455178,
		46.6926512,
		"Чорнобаївка"
	],
	[
		23.865362,
		49.887474,
		"Кожичі"
	],
	[
		22.66342,
		48.46413,
		"Клячаново"
	],
	[
		25.127451,
		50.280991,
		"Митниця"
	]
];

// let map = L.map('map').setView([49.09, 33.43], 8);
// L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
// 	attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
// }).addTo(map);

// for (let i = 0; i < markers.length; i++) {
// 	let lon = markers[i][0];
// 	let lat = markers[i][1];
// 	let popupText = markers[i][2];

// 	let markerLocation = new L.LatLng(lat, lon);
// 	let marker = new L.Marker(markerLocation);
// 	map.addLayer(marker);
// 	marker.bindPopup(popupText);
// }


let map = L.map('map').setView([49.09, 33.43], 8);
let mapLink = '<a href="https://openstreetmap.org">OpenStreetMap</a>';
L.tileLayer(
	'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
	attribution: '&copy; ' + mapLink + ' Contributors',
	maxZoom: 18,
}).addTo(map);

for (var i = 0; i < markers.length; i++) {
	let marker = new L.marker([markers[i][1], markers[i][0]])
		.bindPopup(markers[i][2])
		.addTo(map);
}
